<template>
  <div class="overlay" @click.self="$emit('fechar')">
    <div class="modal-filtros">
      <div class="modal-header">
        <span class="modal-label">Filtros Ação</span>
        <button class="btn-fechar-modal" @click="$emit('fechar')">
          ×
        </button>
      </div>

      <div class="modal-corpo">
        <div class="coluna">
          <p class="coluna-titulo">Unidade:</p>
          <select v-model="filtros.unidadeId" class="select-unidade" :class="{
            selecionado:
              filtros.unidadeId !== null && filtros.unidadeId !== '',
          }">
            <option :value="null">Todas as unidades</option>
            <option v-for="unidade in unidades" :key="unidade.id" :value="unidade.id">
              {{ unidade.nome.toUpperCase() }}
            </option>
          </select>
        </div>
      </div>

      <div class="modal-rodape">
        <button class="btn-limpar" @click="limparFiltros">
          Limpar filtros
        </button>
        <button class="btn-filtrar" @click="aplicarFiltros">
          Filtrar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import unidadesService from "@/service/unidadesService";

const props = defineProps({
  filtrosIniciais: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["fechar", "aplicarFiltros"]);

const unidades = ref([]);

const filtros = ref({
  unidadeId: props.filtrosIniciais?.unidadeId || null,
});

onMounted(async () => {
  try {
    const lista = await unidadesService.getAllUnidades(0, 1000);
    if (lista && Array.isArray(lista)) {
      unidades.value = lista;
    }
  } catch (e) {
    console.error("Erro ao carregar unidades:", e);
  }
});

function limparFiltros() {
  filtros.value = { unidadeId: null };
  emit("aplicarFiltros", { unidadeId: null });
  emit("fechar");
}

function aplicarFiltros() {
  emit("aplicarFiltros", { ...filtros.value });
  emit("fechar");
}
</script>

<style scoped>
.modal-filtros {

  width: 550px;

}

.modal-corpo {
  display: flex;
  flex-direction: column;
  background: var(--branco);
}

.coluna {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.coluna-titulo {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--preto);
  margin-bottom: 0px;
}

.select-unidade {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--roxo-claro);
  border-radius: 8px;
  font-size: 14px;
  color: var(--cinza-escuro);
  background: var(--branco);
  cursor: pointer;
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23563578' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
}

.select-unidade:focus {
  border-color: var(--roxo-primario);
  box-shadow: 0 0 0 3px hsla(258, 53%, 28%, 0.15);
}

.btn-limpar {
  border: 2px solid var(--roxo-medio);
  background: var(--branco);
  color: var(--roxo-medio);
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-limpar:hover {
  background: var(--roxo-superficie);
}

.btn-filtrar {
  background: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-filtrar:hover {
  background: var(--roxo-medio);
}

.select-unidade.selecionado {
  border-color: var(--roxo-primario) !important;
  background-color: var(--roxo-superficie) !important;
  color: var(--roxo-primario) !important;
  font-weight: 600 !important;
  box-shadow: 0 0 0 3px hsla(258, 53%, 28%, 0.08) !important;
}
</style>
